module.exports = __webpack_public_path__ + "img/icon_trade_eye_colse@2x.ef7b1def.png";